import { defineStore } from 'pinia'

export const useAuthStore = defineStore('userInfo', {
  state: () => {
    return {
      auth: {
        userInfo: {},
        isAuthentication: false,
        isRefreshingToken: false,
        showModalChangePassword: false,
        accessToken: '',
        mqttToken: '',
        memberCompanyId: '',
        memberCompanyCode: '',
        refreshToken: ''
      }
    }
  },
  actions: {
    setUserInfo(payload: any) {
      this.auth.userInfo = payload
    },
    setIsAuthentication(payload: boolean) {
      this.auth.isAuthentication = payload
    },
    setIsRefreshingToken(payload: boolean) {
      this.auth.isRefreshingToken = payload
    },
    setShowModalChangePassword(payload: boolean) {
      this.auth.showModalChangePassword = payload
    },
    setMqttToken(token: string) {
      this.auth.mqttToken = token
    },
    setAccessToken(token: string) {
      this.auth.accessToken = token
    },
    setRefreshToken(token: string) {
      this.auth.refreshToken = token
    },
    setMemberCompanyId(memberCompanyId: string) {
      this.auth.memberCompanyId = memberCompanyId
    },
    setMemberCompanyCode(memberCompanyCode: string) {
      this.auth.memberCompanyCode = memberCompanyCode
    }
  }
})
